import React from 'react'
import styled, { css } from 'styled-components'
import Link from 'gatsby-link'
import { colors, rhythm, media, fonts } from '../utils/style-utils'
import FancyNumber from './FancyNumber'
import FancyTitle from './FancyTitle'
import { Subscribe } from 'unstated'
import AppContainer from './AppContainer'

const Wrapper = styled.section`
  margin: ${rhythm(5)} auto;
`

const Grid = styled.div`
  ${media.tablet`
    display: flex;
    flex-wrap: wrap;
`};
`

const GridColumn = styled.div`
  ${media.tablet`
    width: 50%;
    margin-left: auto;
  `};
  position: relative;
`

const Content = styled.div`
  background: ${colors.mercury};
  position: relative;

  padding: ${rhythm(1)};  

  ${media.tablet`
    padding: ${rhythm(2)};
  `}

  ${media.desktop`
    padding: ${rhythm(4)};
  `}

  ${props =>
    props.fancy &&
    css`
      ${media.desktop`
      &::before {
        content: '';
        display: block;
        width: 100%;
        height: 200px;
        bottom: 100%;
        left: 0;
        background: inherit;
        position: absolute;
        z-index: -1;
      }
      `};
    `};
`

const Footer = styled.footer``

const Button = styled.button`
  cursor: pointer;
  display: inline-block;
  font-weight: bold;
  text-transform: uppercase;
  background: ${colors.black};
  color: ${colors.white};
  padding: 2em 2em;
  padding-right: calc(2em + 2em + 4em);
  text-decoration: none;
  letter-spacing: 0.24em;
  position: relative;
  font-size: 10px;
  border: 0;

  ${media.desktop`
    font-size: 14px;
  `} &::after {
    position: absolute;
    content: '';
    display: block;
    width: 4em;
    top: 50%;
    right: 2em;
    border-bottom: 1px solid currentcolor;
  }
`

const Image = styled.img`
  height: auto;
  display: block;
  margin: 0 auto;
  position: relative;
  z-index: 10;
  margin-bottom: -10%;

  width: 75%;
  ${media.tablet`
    width: 55%;
  `};
`

const Title = styled(FancyTitle)`
  margin: ${rhythm(4)} 0 ${rhythm(1)};
  ${media.tablet`
    width: 50%;
    float: right;
    padding: 0 0.5em;
    margin: 0;
    margin-top: ${rhythm(4)};
  `};
`

const Number = styled(FancyNumber)`
  position: absolute;
  top: -1.5em;
`

const ParagraphWithImage = props => {
  const { data, number } = props
  return (
    <Subscribe to={[AppContainer]}>
      {appContainer => (
        <Wrapper className="l-constrained">
          <Image
            src={data.frontmatter.cover.file.childImageSharp.original.src}
            alt={data.frontmatter.cover.alt}
          />
          <Grid>
            <GridColumn>
              <Number className="bert">{number}</Number>
              <Title>{data.frontmatter.title}</Title>
            </GridColumn>
            <GridColumn>
              <Content fancy dangerouslySetInnerHTML={{ __html: data.html }} />
              <Footer>
                <Button onClick={appContainer.openOrderModal}>
                  {data.frontmatter.link.label}
                </Button>
              </Footer>
            </GridColumn>
          </Grid>
        </Wrapper>
      )}
    </Subscribe>
  )
}

export default ParagraphWithImage



// WEBPACK FOOTER //
// ./src/components/ParagraphWithImage.js